import { render, staticRenderFns } from "./CardSectionElementCardField.vue?vue&type=template&id=2d5a17b3"
import script from "./CardSectionElementCardField.vue?vue&type=script&lang=js"
export * from "./CardSectionElementCardField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports